<template>
  <div class="register-container add" >
    <div class="close-form-btn" @click="cancel"></div>
    <form @submit.prevent>
      <div class="form-inner" :class="{scroll: focus}">
        <dl class="inline width-70">
          <dt>写真アップロード</dt>
          <dd>
            <input id="fileUploadData" type="file" name="fileData" ref="file" accept="image/*" multiple @click="resetImageUploader()" @change="uploadFile($event)"/>
          </dd>
        </dl>
        <dl class="inline width-30">
          <dt>写真の月</dt>
          <dd>
            <select class="select-box" v-model="month">
              <option v-for="n in 12" v-bind:value="n" :key="n">{{ n }}月</option>
            </select>
          </dd>
        </dl>
        <dl class="inline width-100">
          <dd>
            <p v-if="formErrorPostImage" class="alert">{{error}}</p>
          </dd>
        </dl>
        <dl>
          <dt>写真コメント</dt>
          <dd>
            <input class="input-text" type="text" v-model="comment" @input="formErrorComment = false" @focus="focus = true" @blur="focus = false">
            <p v-show="formErrorComment" class="alert">入力してください</p>
          </dd>
        </dl>
        <div id="previewContainer"  v-bind:key="file.id" v-for="(file, index) in files">
          <img id="previewImage" :src="file.src"><span>{{file.file.name}}</span>
          <div class="deleteButton" @click="removeFile(index)"></div>
        </div>
        <div class="btn-wrap">
          <button type="cancel" class="cancel-button" @click="cancel">キャンセル</button>
          <button type="submit" class="save-button" @click="save">登録</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import utils from '../../../utils/vue/Utils'

export default {
  name: 'image-add-form',
  data () {
    return {
      postImages: [],
      error: '',
      comment: '',
      formErrorName: '',
      formErrorPostImage: false,
      formErrorComment: false,
      focus: false,
      files: [],
      resizedImages: [],
      month: new Date().getMonth() + 1
    }
  },
  methods: {
    resetImageUploader () {
      this.$refs.file.value = ''
      this.month = new Date().getMonth() + 1
    },
    uploadFile (e) {
      this.files = []
      this.resizedImages = []
      this.formErrorPostImage = false

      if (e.target.files.length > 5) {
        document.getElementById('fileUploadData').value = ''
        this.error = `${this.constant.upload.maxFile}枚以内の画像を選択してください`
        this.formErrorPostImage = true
      }

      // Get files upload data
      for (var i = 0; i < e.target.files.length; i++) {
        var file = e.target.files[i]
        var image = { id: i, src: URL.createObjectURL(file), file: file, month: '1' }
        this.files.push(image)
      }

      this.postImages = e.target.files
    },
    removeFile (index) {
      var listFile = []
      this.formErrorPostImage = false

      this.files.splice(index, 1)

      for (var i = 0; i < this.files.length; i++) {
        listFile.push(this.files[i].file)
      }
      this.postImages = listFile
    },
    async save () {
      // Form input validation
      this.formErrorName = false
      this.formErrorDescription = false
      this.formErrorPostImage = false
      this.formErrorComment = false
      if (this.name === '') {
        this.formErrorName = true
      }
      if (this.description === '') {
        this.formErrorDescription = true
      }

      if (this.comment === '') {
        this.formErrorComment = true
      }

      if (this.postImages.length === 0) {
        this.error = '画像を選択してください'
        this.formErrorPostImage = true
      }

      if (this.formErrorName || this.formErrorDescription || this.formErrorPostImage || this.formErrorComment) {
        return
      }

      // Resize Images
      for (var i = 0; i < this.postImages.length; i++) {
        const url = await this.resizeImage(this.postImages[i])
        this.resizedImages.push(this.dataURItoFile(url))
      }

      this.updateArticle()
    },
    updateArticle () {
      // Set up api parameters
      let params = new FormData()
      params.append('article_id', this.store.getters['detail/getId'])
      params.append('comment', this.comment)
      if (this.getItem('user_id')) {
        params.append('user_id', this.getItem('user_id'))
      }
      for (var i = 0; i < this.postImages.length; i++) {
        params.append('months[]', this.month)
      }
      for (var k in this.resizedImages) {
        params.append('post_images[]', this.resizedImages[k])
      }

      // Call API to upload files to server
      this.postUserApi('articles/update', params).then((res) => {
        this.resetForm()

        this.store.dispatch('modal/setMessage1', '保存しました')
        this.store.dispatch('menu/setAddForm', false)
        this.dispatchImageChanged()
      }).catch((error) => {
        console.error(error)
      })
    },
    dispatchImageChanged () {
      let params = new FormData()
      params.append('article_id', this.store.getters['detail/getId'])
      this.postUserApi('articles/getImages', params).then((res) => {
        this.store.dispatch('detail/setImageUrl', res.data)
      })
    },
    cancel () {
      // アニメーションの関係上手動で初期化
      this.resetForm()
      this.store.dispatch('menu/setAddForm', false)
    },
    resetForm () {
      // Reset form input
      this.month = new Date().getMonth() + 1
      this.files = []
      this.postImages = []
      this.resizedImages = []
      document.getElementById('fileUploadData').value = ''
      this.error = ''
      this.comment = ''
      this.formErrorPostImage = false
      this.formErrorComment = false
    }
  },
  mixins: [utils]
}
</script>

<style lang="scss" scoped src="../scss/ImageAddForm.scss"></style>



// WEBPACK FOOTER //
// src/components/register/vue/ImageAddForm.vue